/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Grid,
  Header,
  Form as FormUi,
  Icon,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import MandatoryMark from "../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";

const VehicleDetailModal = ({
  id,
  data,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [VehicleDetail, setVehicleDetail] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getVehicleDetail();
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let viewPDF = (e, data) => {
    console.log(data);
    let path = `${process.env.REACT_APP_HIRE}/vendor_onboarding/resource?customerNo=${localStorage.getItem("customerNumber")}&resource_url=${data.pdf_value}`
    window.open(path, "_blank");
  }

  const handleSubmited = () => {
        setmodalOpen(false);
  };

  const getVehicleDetail = () => {
    ReadAxios({ url: `vehicleMaster/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleDetail([])
          : setVehicleDetail(res.data.resultSet[0]);
      })
      .catch((err) => {
        setVehicleDetail([]);
      });
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
        <Button 
            // user_items={object} 
            type="button" 
            add_mode="edit" 
            onClick={handleOpen} 
            size="mini"  
            basic 
            icon
        > 
            <Icon name="eye" /> 
        </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Broadcast Shipment"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
                <Grid columns={4} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_no") || "Vehicle Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleNumber ? VehicleDetail.vehicleNumber : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_type") || "Vehicle Type"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleType ? VehicleDetail.vehicleType : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_ownership") || "Vehicle Owner"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleOwner ? VehicleDetail.vehicleOwner : "NA"}
                      </Header>
                    </Grid.Column>

                    
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.tracking_type") || "Tracking Type"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.trackingType ? VehicleDetail.trackingType  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.gps_vendor") || "Vehicle Gps"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleGps ? VehicleDetail.vehicleGps  : "NA"}
                      </Header>
                    </Grid.Column>

                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.base_location") || "Vehicle BaseLocation"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleBaseLocation ? VehicleDetail.vehicleBaseLocation : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_load_capacity") || "Vehicle Capacity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleCapacity ? VehicleDetail.vehicleCapacity : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_dimension") || "Vehicle Dimensions"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleDimensions ? VehicleDetail.vehicleDimensions  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.puc") || "Vehicle Capacity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehiclePUCExpiryDate ? moment(VehicleDetail.vehiclePUCExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      {VehicleDetail.vehiclePUCFile ? (
                          <Button size="mini" onClick={viewPDF} pdf_value={VehicleDetail.vehiclePUCFile} color="facebook" icon><Icon name="download" /> PDF</Button>
                        ) : (null)}
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.insurance") || "Vehicle Dimensions"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleInsuranceExpiryDate ? moment(VehicleDetail.vehicleInsuranceExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      {VehicleDetail.vehicleInsuranceFile ? (
                          <Button size="mini" onClick={viewPDF} pdf_value={VehicleDetail.vehicleInsuranceFile} color="facebook" icon><Icon name="download" /> PDF</Button>
                        ) : (null)}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.fitness_certificate") || "Vehicle Capacity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleFitnessCertExpiryDate ? moment(VehicleDetail.vehicleFitnessCertExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      {VehicleDetail.vehicleFitnessCertFile ? (
                          <Button size="mini" onClick={viewPDF} pdf_value={VehicleDetail.vehicleFitnessCertFile} color="facebook" icon><Icon name="download" /> PDF</Button>
                        ) : (null)}
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.permit") || "Vehicle Dimensions"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehiclePermitExpiryDate ? moment(VehicleDetail.vehiclePermitExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      {VehicleDetail.vehiclePermitFile ? (
                        <Button size="mini" onClick={viewPDF} pdf_value={VehicleDetail.vehiclePermitFile} color="facebook" icon><Icon name="download" /> PDF</Button>
                      ) : (null)}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_rc") || "Vehicle Capacity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleRCNo ? VehicleDetail.vehicleRCNo : "NA"}<br></br>
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.vehicle_rc_expiry") || "Vehicle RC Expiry Date"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                         {VehicleDetail.vehicleRCNoExpiryDate ? moment(VehicleDetail.vehicleRCNoExpiryDate).format("DD-MM-YYYY") : null}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.road_tax") || "Vehicle Dimensions"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleRoadTaxValidityDate ?  moment(VehicleDetail.vehicleRoadTaxValidityDate).format("DD-MM-YYYY") : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("ok") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("vehicle")(VehicleDetailModal)
);
